import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Breadcum from "../../components/breadcum";
import ButtonPrimary from "../../components/button_primary";
const images = [
  "/img/landing/place.jpg",
  "/img/landing/about.jpg",
  "/img/landing/header.jpg",
];

export default function Header() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="relative h-screen w-full overflow-hidden" id="inicio">
      <div className="absolute inset-0 z-0">
        {images.map((src, index) => {
          const isActive = index === currentImage;

          return (
            <motion.img
              key={index}
              src={src}
              initial={{ opacity: 0, y: 0, scale: 1.2 }}
              animate={{
                opacity: isActive ? 1 : 0,
                y: isActive ? -50 : 0,
                scale: 1.2,
              }}
              transition={{
                opacity: { duration: 1.2, ease: "easeInOut" },
                y: { duration: 5, ease: "easeInOut" },
              }}
              className="absolute w-full h-full object-cover"
              style={{
                zIndex: isActive ? 1 : 0,
              }}
            />
          );
        })}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />
      </div>

      <div className="relative z-20 h-full flex items-center justify-start text-white px-12 mx-auto max-w-screen-2xl">
        <div className="max-w-screen-lg text-left">
          <Breadcum text={"Seguridad Privada"}/>
          <h1 className="text-6xl font-bold uppercase tracking-wide">
            Border Protect Seguridad Privada
          </h1>
          <p className="text-lg mt-4 text-gray-300">
            En Border Protect Seguridad Privada, ofrecemos seguridad y
            vigilancia privada para proteger lo que más importa. Nuestros
            servicios están respaldados por certificaciones oficiales y un
            equipo de seguridad altamente entrenado.
          </p>
          <div className="flex gap-8">
            <ButtonPrimary href={"contacto"} text={"Contáctanos"} type={"second"}/>
            <ButtonPrimary href={"servicios"} text={"Nuestros Servicios"} type={"primary"}/>
          </div>
        </div>
      </div>
    </header>
  );
}
